"use strict";
const HOVER = window.matchMedia("(hover: hover) and (pointer: fine)");
const plural = (count) => `${count} ${count === 1 ? "validaci\xF3n" : "validaciones"}`;
const decimal = (value) => value === null || value === void 0 ? "\u2014" : String(value).replace(".", ",");
const el = (tag, className, text) => {
  const node = document.createElement(tag);
  if (className) {
    node.className = className;
  }
  if (text !== void 0) {
    node.textContent = text;
  }
  return node;
};
const initFocasosValidaciones = () => {
  const meta = document.querySelector("meta[name='focasos-validaciones']");
  if (!meta || document.body.dataset.focasosValidaciones) {
    return;
  }
  document.body.dataset.focasosValidaciones = "on";
  const countsUrl = meta.content;
  const showUrl = (blockId) => countsUrl.replace(/\/focasos\/encuestas\/\d+\/validaciones$/, `/focasos/validaciones/${blockId}`);
  const widgets = /* @__PURE__ */ new Map();
  let openWidget = null;
  const close = (widget) => {
    if (!widget) {
      return;
    }
    widget.panel.hidden = true;
    widget.button.setAttribute("aria-expanded", "false");
    widget.pinned = false;
    if (openWidget === widget) {
      openWidget = null;
    }
  };
  const render = (widget, data) => {
    const { panel } = widget;
    panel.replaceChildren();
    const head = el("div", "focasos-validaciones__cabecera");
    head.append(el("strong", null, `Validaciones de la acci\xF3n ${data.code}`));
    const closeButton = el("button", "focasos-validaciones__cerrar", "\xD7");
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Cerrar");
    closeButton.addEventListener("click", () => {
      close(widget);
      widget.button.focus();
    });
    head.append(closeButton);
    panel.append(head);
    if (!data.total) {
      panel.append(el("p", "focasos-validaciones__vacio", "Nadie ha valorado a\xFAn esta acci\xF3n."));
      return;
    }
    panel.append(el(
      "p",
      "focasos-validaciones__resumen",
      `${data.total} ${data.total === 1 ? "persona" : "personas"} \xB7 Importancia media ${decimal(data.importance_average)} \xB7 Urgencia media ${decimal(data.urgency_average)}`
    ));
    const list = el("ul", "focasos-validaciones__lista");
    data.ratings.forEach((rating) => {
      const item = el("li", rating.own ? "is-own" : null);
      const name = rating.profile_path ? el("a", "focasos-validaciones__nombre", rating.name) : el("span", "focasos-validaciones__nombre", rating.name);
      if (rating.profile_path) {
        name.href = rating.profile_path;
        name.target = "_blank";
        name.rel = "noopener";
      }
      item.append(name);
      const scores = el("span", "focasos-validaciones__puntos");
      const imp = el("span", null, `Imp. ${rating.importance || "\u2014"}`);
      imp.title = "Importancia (1\u20135)";
      const urg = el("span", null, `Urg. ${rating.urgency || "\u2014"}`);
      urg.title = "Urgencia (1\u20133)";
      scores.append(imp, urg);
      item.append(scores);
      list.append(item);
    });
    panel.append(list);
  };
  const open = (widget, pinned) => {
    if (openWidget && openWidget !== widget) {
      close(openWidget);
    }
    openWidget = widget;
    widget.pinned = widget.pinned || pinned;
    widget.button.setAttribute("aria-expanded", "true");
    widget.panel.hidden = false;
    widget.panel.replaceChildren(el("p", "focasos-validaciones__vacio", "Cargando\u2026"));
    fetch(showUrl(widget.blockId), { headers: { Accept: "application/json" }, credentials: "same-origin" }).then((response) => response.ok ? response.json() : Promise.reject(response)).then((data) => {
      if (openWidget === widget) {
        render(widget, data);
        widget.setCount(data.total);
      }
    }).catch(() => {
      widget.panel.replaceChildren(el("p", "focasos-validaciones__vacio", "No se ha podido cargar la lista."));
    });
  };
  document.querySelectorAll(".question[data-question-id]").forEach((question) => {
    const links = question.querySelector(".focasos-accion .focasos-accion__debate");
    if (!links) {
      return;
    }
    const blockId = question.dataset.questionId;
    const wrapper = el("span", "focasos-validaciones");
    const button = el("button", "focasos-validaciones__boton");
    button.type = "button";
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-controls", `focasos-validaciones-${blockId}`);
    const panel = el("div", "focasos-validaciones__panel");
    panel.id = `focasos-validaciones-${blockId}`;
    panel.setAttribute("role", "region");
    panel.setAttribute("aria-label", "Qui\xE9n ha valorado esta acci\xF3n");
    panel.hidden = true;
    wrapper.append(button, panel);
    links.prepend(wrapper);
    const widget = { blockId, button, panel, pinned: false, hoverTimer: null };
    widget.setCount = (count) => {
      button.textContent = plural(count);
    };
    widget.setCount(0);
    widgets.set(blockId, widget);
    button.addEventListener("click", () => {
      if (!panel.hidden && widget.pinned) {
        close(widget);
      } else {
        open(widget, true);
      }
    });
    wrapper.addEventListener("mouseenter", () => {
      if (!HOVER.matches) {
        return;
      }
      clearTimeout(widget.hoverTimer);
      if (panel.hidden) {
        widget.hoverTimer = setTimeout(() => open(widget, false), 250);
      }
    });
    wrapper.addEventListener("mouseleave", () => {
      if (!HOVER.matches) {
        return;
      }
      clearTimeout(widget.hoverTimer);
      if (!widget.pinned) {
        widget.hoverTimer = setTimeout(() => close(widget), 300);
      }
    });
  });
  if (!widgets.size) {
    return;
  }
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && openWidget) {
      const { button } = openWidget;
      close(openWidget);
      button.focus();
    }
  });
  document.addEventListener("click", (event) => {
    if (openWidget && !event.target.closest(".focasos-validaciones")) {
      close(openWidget);
    }
  });
  const loadCounts = () => {
    fetch(countsUrl, { headers: { Accept: "application/json" }, credentials: "same-origin" }).then((response) => response.ok ? response.json() : Promise.reject(response)).then((counts) => {
      widgets.forEach((widget, blockId) => widget.setCount(counts[blockId] || 0));
    }).catch(() => {
    });
  };
  let refreshTimer = null;
  document.addEventListener("focasos:autosaved", () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(loadCounts, 800);
  });
  loadCounts();
};
document.addEventListener("turbo:load", initFocasosValidaciones);
